export default __webpack_public_path__ + "static/media/image7.7864dff5.svg";